import { useEffect } from "react";

export const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title
      ? `${title} | Jaiswal Tent House`
      : "Jaiswal Tent House | Tent & Event Decoration in Bilaspur";
  }, [title]);
};
